import { useState, useEffect, useRef } from 'react'
import brand from '@/config/brand'
import config from '@/lib/config'

const RGS_HOST = new URL(config.backendUrl).hostname
const GAME_URL = process.env.REACT_APP_GAME_URL || 'https://televega-slots.pages.dev'

export default function TvSlots({ playMode = 'demo' }) {
  const [sessionID, setSessionID] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)
  const iframeRef = useRef(null)

  useEffect(() => {
    const getSession = async () => {
      setLoading(true)
      setError(null)

      try {
        const res = await fetch(`${config.backendUrl}/rgs/session`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ playMode }),
        })
        const data = await res.json()
        if (!res.ok || !data.sessionID) {
          setError(data.error || 'Failed to start game session.')
          return
        }
        setSessionID(data.sessionID)
      } catch (e) {
        setError('Failed to start game session.')
      } finally {
        setLoading(false)
      }
    }
    getSession()
  }, [playMode])

  const gameUrl = sessionID
    ? (() => {
        const params = new URLSearchParams({
          sessionID,
          rgs_url: `${RGS_HOST}/rgs`,
          currency: 'USD',
          lang: 'en',
          casino_name: brand.casinoName,
          game_name: 'Gold Reels',
        })

        if (brand.logoUrl) {
          params.set('casino_logo', brand.logoUrl)
        }

        return `${GAME_URL}${GAME_URL.includes('?') ? '&' : '?'}${params.toString()}`
      })()
    : null

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-yellow-400 text-xl animate-pulse">Loading {brand.casinoName} Gold Reels...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-red-400 text-center">
          <p className="text-xl mb-2">{error}</p>
          {playMode === 'account' && (
            <p className="text-sm text-gray-400">Use Free Play or log in before starting account play.</p>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="w-full flex flex-col items-center">
      <div className="w-full max-w-4xl">
        <h1 className="text-yellow-400 text-2xl font-bold mb-4 text-center tracking-wider">
          {brand.casinoName.toUpperCase()} GOLD REELS
        </h1>
        <div className="text-center text-gray-400 text-sm mb-3">
          {playMode === 'demo' ? 'Free Play' : 'Saved Balance'}
        </div>
        <div
          className="w-full rounded-xl overflow-hidden border border-yellow-500/30 shadow-2xl"
          style={{ aspectRatio: '16/9' }}
        >
          {gameUrl && (
            <iframe
              ref={iframeRef}
              src={gameUrl}
              title={`${brand.casinoName} Gold Reels`}
              className="w-full h-full border-0"
              allow="fullscreen"
              sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
            />
          )}
        </div>
        <p className="text-center text-xs text-gray-500 mt-3">
          {playMode === 'demo' ? 'Free-play coins only. No cash value.' : 'Playing with your saved coin balance.'}
        </p>
      </div>
    </div>
  )
}
